import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import CallbackPage from './pages/CallbackPage';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import PrivateRoutes from './components/PrivateRoutes';
import NewsEditPage from './pages/NewsEditPage';
import NewsOverviewPage from './pages/NewsOverviewPage';
import NewsPage from './pages/NewsPage';
import TeamEditPage from './pages/TeamEditPage';
import TeamOverviewPage from './pages/TeamOverviewPage';
import TeamPage from './pages/TeamPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/callback" element={<CallbackPage />} />

        <Route element={<PrivateRoutes />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/news" replace />} />

            <Route path="/news" element={<NewsOverviewPage />} />
            <Route path="/news/new" element={<NewsPage />} />
            <Route path="/news/edit/:id" element={<NewsEditPage />} />

            <Route path="/team" element={<TeamOverviewPage />} />
            <Route path="/team/new" element={<TeamPage />} />
            <Route path="/team/edit/:id" element={<TeamEditPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
